import { Pipe, PipeTransform, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionDataService } from '../services/session-data/session-data.service';
import { switchMap } from 'rxjs/operators';

@Pipe({name: 'transactionDate'})
export class TransactionDatePipe implements PipeTransform, OnInit {

    dateMap = {
        '1': `${this.translate.instant('DATE.JAN')}`,
        '2': `${this.translate.instant('DATE.FEB')}`,
        '3': `${this.translate.instant('DATE.MAR')}`,
        '4': `${this.translate.instant('DATE.APR')}`,
        '5': `${this.translate.instant('DATE.MAI')}`,
        '6': `${this.translate.instant('DATE.JUN')}`,
        '7': `${this.translate.instant('DATE.JUL')}`,
        '8': `${this.translate.instant('DATE.AUG')}`,
        '9': `${this.translate.instant('DATE.SET')}`,
        '10': `${this.translate.instant('DATE.OUT')}`,
        '11': `${this.translate.instant('DATE.NOV')}`,
        '12': `${this.translate.instant('DATE.DEZ')}`,
    };
    constructor(private translate: TranslateService, private sessionDataService: SessionDataService) {}

    ngOnInit() {
        this.sessionDataService.getSessionData().pipe(
            switchMap(sessionData =>
                this.translate.currentLang = sessionData.selectedLanguage
            )
        );
    }

    transform(value: string): string {

        if (value.length === 8) {
            value = value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8);
        } else if (value.length !== 10) {
            return value;
        }

        const separator = ' ';
        const year = value.substring(0, 4);
        let month = value.substring(5, 7);
        let day = value.substring(8, 10);

        if (day.startsWith('0')) {
            day = day.substring(1);
        }

        if (month.startsWith('0')) {
            month = month.substring(1);
        }

        month = this.getMonthDescription(month);
        return day.concat(separator).concat(month).concat(',').concat(separator).concat(year);
      }

      getMonthDescription(month: string): string {
        return this.dateMap[month];
      }
}
